<template>
  <div class="traffic-container">
    <div class="traffic_item mb_80">
      <div class="traffic_type">
          <div>1</div>
          <span class="media_font_size_50">地铁</span>
      </div>
      <el-table :data="metroList" border style="width: 100%;" header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" label="地铁线路"></el-table-column>
        <el-table-column prop="station" label="下车地点"></el-table-column>
        <el-table-column prop="start" label="始发/终点站"></el-table-column>
        <el-table-column prop="time" label="首发/末班"></el-table-column>
        <el-table-column prop="fee" label="全部票价"></el-table-column>
      </el-table>
    </div>
    <div class="traffic_item">
      <div class="traffic_type">
          <div>2</div>
          <span class="media_font_size_50">公交路线</span>
      </div>
      <el-table :data="busList" border header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" label="公交线路" ></el-table-column>
        <el-table-column prop="station" label="下车地点"></el-table-column>
        <el-table-column prop="start" label="始发/终点站"></el-table-column>
        <el-table-column prop="time" label="首发/末班"></el-table-column>
        <el-table-column prop="fee" label="全部票价"></el-table-column>
      </el-table>
    </div>
    <div class="video_wrap">
      <div class="title">
        <h2 class="media_font_size_70" style="margin:10px 0;">广州国际车展</h2>
        <span>AUTOSHOW</span>
      </div>
      <video
        src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gz_19_video.mp4"
        controls
      ></video>
    </div>
    <div class="news_wrap">
      <div class="title">
        <h2 class="media_font_size_70">展会新闻</h2>
        <span>NEWS</span>
      </div>
      <div class="news_container">
        <div class="news_item" v-for="(item,index) in newsList" :key="index">
          <div :style="{'backgroundImage':'url('+item.img+')'}"></div>
          <span class="item_title media_font_size_50">{{item.title}}</span>
          <span class="item_date media_font_size_30">{{item.date}}</span>
        </div>
      </div>
      <div class="default_btn media_font_size_50" @click="handelJump('/newsCenter?tab=0')">查看更多</div>
    </div>
    <div class="map_wrap">
      <img src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/map.png" alt />
    </div>
    <div class="co_wrap">
      <div class="title">
        <h2 class="media_font_size_70">合作媒体</h2>
        <span class="mb_80">MEDIA</span>
      </div>
      <div class="swiper-container coswiper">
        <swiper :options="swiperOption" class="swiper" ref="mySwiper">
          <swiper-slide class="slide" v-for="(item,index) in logoList" :key="index">
            <img :src="item.img" alt />
            <!-- <div class="slide_item" :style="{'backgroundImage':'url('+item.img+')'}"></div> -->
          </swiper-slide>
        </swiper>
      </div>
      <div class="default_btn media_font_size_50">查看更多</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      metroList: [
          {
              line:"8号",
              station:"新港东、琶洲",
              start:"凤凰新村←→万胜围",
              time:"06:15-22:40",
              fee:"6元"
          }
      ],
      busList:[
          {
              line:"137",
              station:"琶洲、琶洲大桥南",
              start:"动物园南门(总站)←→新洲总站",
              time:"06:15-21:45",
              fee:"2元"
          },
          {
              line:"139",
              station:"琶洲、国际会展中心",
              start:"东圃客运站(总站)←→海珠客运站总站",
              time:"06:15-22:00",
              fee:"3元"
          },
          {
              line:"20",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"岑村教练场总站←→赤岗大塘(总站)",
              time:"06:00-22:00",
              fee:"2元"
          },
          {
              line:"229",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"罗冲围总站←→琶洲石基村总站",
              time:"06:00-22:00",
              fee:"2元"
          },
          {
              line:"262",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"赤岗东(总站) ←→ 新洲总站",
              time:"05:50-22:30",
              fee:"2元"
          },
          {
              line:"507",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"大学城总站←→黄埔区政府",
              time:"06:00-21:30",
              fee:"3元"
          },
           {
              line:"564",
              station:"琶洲、琶洲大桥南",
              start:"琶洲黄埔村总站←→天河客运站(总站)",
              time:"06:30-21:30",
              fee:"4元"
          },
           {
              line:"583",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"逸景翠园总站←→车陂(总站)",
              time:"06:30-21:00",
              fee:"2元"
          },
           {
              line:"92",
              station:"琶洲、国际会展中心",
              start:"广州火车东站总站←→江海大道中",
              time:"06:30-22:00",
              fee:"2元"
          },
           {
              line:"大学城3线",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"大学城总站←→广东药学院总站",
              time:"07:30-22:00",
              fee:"3元"
          },
           {
              line:"505",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"塘村总站←→珠江泳场总站",
              time:"06:30-21:30",
              fee:"3元"
          },
          
      ],
      logoList: [
        {
          id: "1",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2020/11/202011101357455745.jpg",
          url: ""
        },
        {
          id: "2",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2020/10/202010101442494249.jpg",
          url: ""
        },
        {
          id: "3",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/11/201911051345254525.jpg",
          url: ""
        },
        {
          id: "4",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/09/20190926160832832.png",
          url: ""
        },
        {
          id: "5",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2019/09/20190926160736736.png",
          url: ""
        },
        {
          id: "6",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2018/11/201811081446324632.jpg",
          url: ""
        },
        {
          id: "7",
          img:
            "http://autoguangzhou.com.cn/uploadfiles/2018/11/20181102180620620.png",
          url: ""
        }
      ],
      newsList: [
        {
          title:
            "新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/newscover.jpeg",
          date: "2020-11-22"
        },
        {
          title: "新闻标题",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/newscover.jpeg",
          date: "2020-11-22"
        },
        {
          title: "新闻标题",
          img:
            "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/newscover.jpeg",
          date: "2020-11-22"
        }
      ],
      swiperOption: {
        // 所有的参数同 swiper 官方 api 参数
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        slidesPerView: 5,
        spaceBetween: 40,
        autoHeight: true,
        autoplay: 3000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  methods: {
    tableHeadClassName({row, rowIndex}) {
        console.log(row,rowIndex)
      return "head-row";
    },
    handelPre() {},
    handelNext() {},
    handelJump(path){
      this.$router.push(path)
    }
  }
};
</script>

<style lang="scss">
.traffic-container {
  width: 1200px;
  .traffic_item {
      .traffic_type{
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          >div{
            min-width: 36px;
            // min-height: 36px;
            padding:15px;
            border-radius: 50%;
            box-sizing: border-box;
            background: #E16A13;
            color: #fff;
            margin-right: 17px;
            text-align: center;
            font-weight: bold;
            // line-height: 36px;
          }
          >span{
              font-size: 30px;
              color: #fff;
          }
      }
  }
  .desc_wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    margin-bottom: 102px;
    > span {
      color: rgba($color: #fff, $alpha: 0.5);
      font-size: 24px;
    }
  }
  .video_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    > video {
      width: 1200px;
      margin-top: 49px;
    }
  }
  .news_wrap {
    margin-top: 99px;
    .news_container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .news_item {
        display: flex;
        flex-direction: column;
        color: #fff;
        > div {
          width: 370px;
          height: 260px;
          background-size: cover;
          background-position: center;
        }
        .item_title {
          color: #fff;
          width: 370px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 26px 0px 50px 0px;
          font-size: 22px;
        }
        .item_date {
          font-size: 16px;
          color: rgba($color: #fff, $alpha: 0.5);
        }
      }
    }
  }
  .map_wrap {
    display: flex;
    margin: 120px 0px;
    > img {
      width: 100%;
      height: 908px;
    }
  }
  .co_wrap {
    .swiper-container {
      height: 100px;

      .swiper {
        height: 80px;
        .slide {
          width: 125px;
          height: 70px;
          > img {
            width: 100%;
            height: 100%;
          }
          .slide_item {
            // width: 100%;
            height: 100px;
            background: #fff;
            background-size: cover;
            background-position: center;
          }
        }
      }
    }
  }
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  > h2 {
    font-size: 36px;
  }
  > span {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.default_btn {
  background: rgba($color: #fff, $alpha: 0.2);
  border-radius: 30px;
  padding:18px;
  width:300px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.5);
  font-size: 24px;
  margin: 60px auto;
}
.mb_80 {
  margin-bottom: 80px;
}
.header-row {
  background: #42abff !important;
  color: #fff;
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// traffic.vue?4c1d2665